import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 font-heading text-lg font-bold text-white mb-4 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-white text-sm font-bold">
                拍
              </span>
              <span>拍得好</span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              {siteInfo.description}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">精选文章</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/article/golden-ratio-self-portrait" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">
                  黄金分割自拍法
                </Link>
              </li>
              <li>
                <Link to="/article/street-candid-beginner" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">
                  街头抓拍入门
                </Link>
              </li>
              <li>
                <Link to="/article/lightroom-mobile-portrait" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">
                  Lightroom调色全攻略
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-foreground-300">
              <li>邮箱：{siteInfo.email}</li>
              <li>微信：{siteInfo.wechat}</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} {siteInfo.name} · 保留所有权利
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <Link to="/about" className="hover:text-white transition-colors cursor-pointer">关于我们</Link>
            <span>·</span>
            <Link to="/" className="hover:text-white transition-colors cursor-pointer">首页</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}